module.exports = __webpack_public_path__ + "media/images/recruit/entry/icon-arrow-a160e07adc877f2c8ebb39cc4ccc8ee9.svg";